import { render, staticRenderFns } from "./IssuingAgentList.vue?vue&type=template&id=97af0112&scoped=true&"
import script from "./IssuingAgentList.vue?vue&type=script&lang=js&"
export * from "./IssuingAgentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97af0112",
  null
  
)

export default component.exports